import React from "react";
import { useAppStore } from "../../../appStore";
import { UserDropDownSMTP } from "./UserDropDownSMTP";
import { SiteDropDownSMTP } from "./SiteDropDownSMTP";
import { CameraDropDownSMTP } from "./CameraDropDownSMTP";
import { StartDateDropDownSMTP } from "./StartDateDropDownSMTP";
import { EndDateDropDownSMTP } from "./EndDateDropDownSMTP";
import { StartTimeDropDownSMTP } from "./StartTimeDropDownSMTP";
import { EndTimeDropDownSMTP } from "./EndTimeDropDownSMTP";
import { ApplyFiltersButtonSMTP } from "./ApplyFiltersButtonSMTP";

export const SMTPTabFilters = ({
  navBarCollapsed,
  showUserDropDown,
  userOptions,
  setSearchParams,
}: {
  navBarCollapsed: boolean;
  showUserDropDown: boolean;
  userOptions: any;
  setSearchParams?: (params: URLSearchParams) => void;
}) => {
  const { userPermissions } = useAppStore();

  let noUserDropDownCSS = showUserDropDown
    ? [
        "absolute top-0 left-[160px]",
        "absolute top-0 left-[320px]",
        "absolute top-0 left-[480px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[800px]",
        "absolute top-0 left-[960px]",
        "absolute top-[8px] left-[1130px]",
        "absolute top-0",
      ]
    : [
        "absolute top-0",
        "absolute top-0 left-[210px]",
        "absolute top-0 left-[420px]",
        "absolute top-0 left-[580px]",
        "absolute top-0 left-[740px]",
        "absolute top-0 left-[900px]",
        "absolute top-[8px] left-[1065px]",
      ];

  if (showUserDropDown && navBarCollapsed) {
    noUserDropDownCSS = [
      "absolute top-0 left-[185px]",
      "absolute top-0 left-[370px]",
      "absolute top-0 left-[555px]",
      "absolute top-0 left-[715px]",
      "absolute top-0 left-[875px]",
      "absolute top-0 left-[1035px]",
      "absolute top-[8px] left-[1205px]",
      "absolute top-0",
    ];
  }

  if (!showUserDropDown && navBarCollapsed) {
    noUserDropDownCSS = [
      "absolute top-0",
      "absolute top-0 left-[250px]",
      "absolute top-0 left-[495px]",
      "absolute top-0 left-[655px]",
      "absolute top-0 left-[815px]",
      "absolute top-0 left-[975px]",
      "absolute top-[8px] left-[1140px]",
    ];
  }
  return (
    <div
      className={
        userPermissions.smtp &&
        (userPermissions.sentinel || userPermissions.ailink)
          ? "absolute top-[60px] left-0"
          : "absolute top-[0px] left-0"
      }
    >
      {showUserDropDown && (
        <div className={noUserDropDownCSS[7]}>
          <UserDropDownSMTP navBarCollapsed={navBarCollapsed} />
        </div>
      )}
      <div className={noUserDropDownCSS[0]}>
        <SiteDropDownSMTP
          showUserDropDown={showUserDropDown}
          navBarCollapsed={navBarCollapsed}
        />
      </div>
      <div className={noUserDropDownCSS[1]}>
        <CameraDropDownSMTP
          showUserDropDown={showUserDropDown}
          navBarCollapsed={navBarCollapsed}
        />
      </div>
      <div className={noUserDropDownCSS[2]}>
        <StartDateDropDownSMTP />
      </div>
      <div className={noUserDropDownCSS[3]}>
        <EndDateDropDownSMTP />
      </div>
      <div className={noUserDropDownCSS[4]}>
        <StartTimeDropDownSMTP />
      </div>
      <div className={noUserDropDownCSS[5]}>
        <EndTimeDropDownSMTP />
      </div>
      <div className={noUserDropDownCSS[6]}>
        <ApplyFiltersButtonSMTP setSearchParams={setSearchParams} />
      </div>
    </div>
  );
};
